export const updateAllMatchingPaths = (
  json: any,
  path: string,
  callback: (v: any) => any
): object => {
  if (Array.isArray(json)) {
    // If the current JSON node is an array, map through each element and transform recursively
    return json.map((item) => updateAllMatchingPaths(item, path, callback));
  } else if (typeof json === 'object' && json !== null) {
    // If the current JSON node is an object, create a new object to store the transformed values
    const newObj = { ...json };
    const keys = path.split('.');
    const keyToMatch = keys[0];

    if (keyToMatch in newObj) {
      if (keys.length === 1) {
        // If this is the final key in the path, update its value using the callback
        newObj[keyToMatch] = callback(newObj[keyToMatch]);
      } else if (typeof newObj[keyToMatch] === 'object') {
        // Recursively process the next part of the path
        newObj[keyToMatch] = updateAllMatchingPaths(
          newObj[keyToMatch],
          keys.slice(1).join('.'),
          callback
        );
      }
    }

    // Recursively process other keys in the object
    for (const key in newObj) {
      newObj[key] = updateAllMatchingPaths(newObj[key], path, callback);
    }

    return newObj;
  }
  // Return non-object, non-array values as-is
  return json;
};
